import React, { useState, useMemo, useEffect } from "react";
import { FaSearch, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { IoIosInformationCircle } from "react-icons/io";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function Requested() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
   const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const rowsPerPage = 8;

  const navigate = useNavigate();

  // ================= ADMIN AUTH =================
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    if (!isLoggedIn || user.usrlst_role?.toLowerCase() !== "admin") {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  // ================= FETCH DATA =================
  useEffect(() => {
  const fetchCompliance = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await apiFetch("/report/admin/compliance");

      const formatted = data.data.map((item) => ({
        id: item.report_id,
        act: item.act,
        particular: item.name,
        title: item.title || "",
        description: item.description || "",
        startDate: item.start_date,
        actionDate: item.action_date,
        endDate: item.end_date,
        status: item.status,
        bu: item.bu_name || "-",
        department: item.dept_name || "-",
        userName: item.user_name || "-",
        approversEmail: item.approvers_email || "-",
        requestDate: item.request_date || "",
        responseDate: item.response_date || "",
      }));

      setData(formatted);
    } catch (error) {
      console.error("Error fetching compliance list:", error);
      setError("Failed to fetch requested records.");
    } finally {
      setLoading(false);
    }
  };

  fetchCompliance();
}, []);

  // ================= FILTER REQUESTED ONLY =================
  const filteredData = useMemo(() => {
    return data
      .filter((item) => item.status?.toLowerCase() === "requested")
      .filter((item) =>
        Object.values(item).join(" ").toLowerCase().includes(searchTerm.toLowerCase())
      );
  }, [data, searchTerm]);

  // ================= SORT =================
  const sortedData = useMemo(() => {
    let sortable = [...filteredData];
    if (sortConfig.key) {
      sortable.sort((a, b) => {
        const valA = (a[sortConfig.key] || "").toString().toLowerCase();
        const valB = (b[sortConfig.key] || "").toString().toLowerCase();
        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortable;
  }, [filteredData, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="sort-icon" />;
    return sortConfig.direction === "asc" ? <FaSortUp className="sort-icon" /> : <FaSortDown className="sort-icon" />;
  };

  // ================= PAGINATION =================
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  // ================= EXPORT =================
  const exportToCSV = () => {
    if (!sortedData.length) return;

    const headers = [
      "Id","Act","Instance","Start Date","Action Date","End Date","Status",
      "BU","Department","User","Approver Email","Request Date","Response Date"
    ];

    const rows = sortedData.map((r) => [
      r.id, r.act, `${r.particular} - ${r.title}`, r.startDate, r.actionDate, r.endDate, r.status,
      r.bu, r.department, r.userName, r.approversEmail, r.requestDate, r.responseDate
    ].map(v => `"${v || ""}"`));

    const csv = [headers.join(","), ...rows.map(r => r.join(","))].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "requested_compliance.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
 const statusCounts = useMemo(() => {
  const counts = {
    requested: 0
  };

  filteredData.forEach((item) => {
    counts.total++;

    const status = item.status?.toLowerCase();
    if (status === "requested") counts.requested++;
  });

  return counts;
}, [filteredData]);

  // ================= UI =================
  return (
    <div className="Requested">
      <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="headSection">
        <div className="compliance-score">Requested Report</div>
      </div>

      <div className="table-header" style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: "10px", marginLeft: "45px" }}>
          <button className="btn blue-btn" onClick={() => navigate("/comprehensive")}>Comprehensive</button>
          <button className="btn blue-btn" onClick={() => navigate("/pending")}>Pending</button>
          <button className="btn blue-btn" onClick={() => navigate("/approved")}>Approved</button>
          <button className="btn gray-btn" onClick={() => navigate("/requested")}>Requested</button>
          <button className="btn blue-btn" onClick={() => navigate("/overdue")}>Overdue</button>
        </div>

        <div className="table-actions" style={{ display: "flex", gap: "15px", alignItems: "center" }}>

  {/* STATUS BADGES */}
  <div style={{ display: "flex", gap: "10px" }}>

    

    

    <div style={{
      background: "#fff3cd",
      color: "#856404",
      padding: "6px 12px",
      borderRadius: "20px",
      fontWeight: "600",
      fontSize: "13px"
    }}>
      Requested: {statusCounts.requested}
    </div>

   
  </div>

  {/* SEARCH */}
  <div className="search-box">
    <input
      placeholder="Search"
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value)}
    />
    <FaSearch className="search-icon" />
  </div>

  {/* EXPORT */}
  <button className="action-btn primary" onClick={exportToCSV}>
    Export
  </button>

</div>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th onClick={() => requestSort("id")}>Id {getSortIcon("id")}</th>
            <th onClick={() => requestSort("act")}>Compliance {getSortIcon("act")}</th>
            <th>Instance</th>
            <th onClick={() => requestSort("startDate")}>Start Date</th>
            <th onClick={() => requestSort("actionDate")}>Action Date</th>
            <th onClick={() => requestSort("endDate")}>End Date</th>
            <th onClick={() => requestSort("status")}>Status</th>
            <th>User</th>
            <th>Approver's Email</th>
            <th onClick={() => requestSort("requestDate")}>Request Date</th>
            <th onClick={() => requestSort("responseDate")}>Response Date</th>
          </tr>
        </thead>
        <tbody>
  {loading ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
        Loading requested records...
      </td>
    </tr>
  ) : error ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center", color: "red" }}>
        {error}
      </td>
    </tr>
  ) : currentRows.length > 0 ? (
    currentRows.map((row, idx) => (
      <tr key={idx}>
        <td>{row.id}</td>
        <td>{row.act}</td>

       <td>
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    <span>
      {row.title
        ? `${row.particular} - ${row.title}`
        : row.particular}
    </span>

    {row.description && (
      <IoIosInformationCircle
        title={row.description}
        style={{
          cursor: "pointer",
          fontSize: "16px",
          color: "#1A1744"
        }}
      />
    )}
  </div>
</td>

        <td>{row.startDate}</td>
        <td>{row.actionDate}</td>
        <td>{row.endDate}</td>
        <td style={{ color: "orange", fontWeight: 600 }}>
          {row.status}
        </td>

        <td>
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    <span>{row.userName}</span>

    {(row.bu || row.department) && (
      <IoIosInformationCircle
        title={`BU: ${row.bu} | Dept: ${row.department}`}
        style={{
          cursor: "pointer",
          fontSize: "16px",
          color: "#1A1744"
        }}
      />
    )}
  </div>
</td>
        <td>{row.approversEmail}</td>
        <td>{row.requestDate}</td>
        <td>{row.responseDate}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="11" style={{ textAlign: "center" }}>
        No requested records found
      </td>
    </tr>
  )}
</tbody>
      </table>

      <div className="pagination">
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>Prev</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>Next</button>
      </div>
    </div>
  );
}
